import {Injectable} from "@angular/core";


@Injectable({providedIn: "root"})

export class ZnakiService {
  constructor() {
  }

  public znaki:any = [
    {
      category: {
        name: "Предупреждающие знаки",
        img_icon: '/assets/znaki/1.1.svg',
        url: "preduprezhdayushchie",
        description:
          "Предупреждающие знаки информируют водителей о приближении к опасному участку дороги, движение по которому требует принятия мер, соответствующих обстановке."
      },
      seo: {
        title: "Предупреждающие знаки ПДД 2026 | ПДД",
        description: "Предупреждающие дорожные знаки ПДД 2026: значение, внешний вид и правила применения. Подробное объяснение для подготовки к экзамену ГИБДД.",
        keywords: "предупреждающие знаки, ПДД знаки, дорожные знаки 2026, знаки ПДД, экзамен ГИБДД"
      },
      list: [
        {
          number: "1.1",
          images: ['1.1'],
          name: "Железнодорожный переезд со шлагбаумом",
          description:
            "** Нумерация дорожных знаков соответствует ГОСТу Р 52290-2004."
        },
        {
          number: "1.2",
          images: ["1.2"],
          name: "Железнодорожный переезд без шлагбаума",
          description: ""
        },
        {
          number: "1.3.1",
          images: ["1.3.1"],
          name: "Однопутная железная дорога",
          description: ""
        },
        {
          number: "1.3.2",
          images: ["1.3.2"],
          name: "Многопутная железная дорога",
          description:
            "Обозначение необорудованного шлагбаумом переезда через железную дорогу: 1.3.1 — с одним путем, 1.3.2 — с двумя путями и более."
        },
        {
          number: "1.4.1 - 1.4.6",
          images: ["1.4.1", "1.4.2", "1.4.3", "1.4.4", "1.4.5", "1.4.6"],
          name: "Приближение к железнодорожному переезду",
          description:
            "Дополнительное предупреждение о приближении к железнодорожному переезду вне населенных пунктов."
        },
        {
          number: "1.5",
          images: ["1.5"],
          name: "Пересечение с трамвайной линией",
          description: ""
        },
        {
          number: "1.6",
          images: ["1.6"],
          name: "Пересечение равнозначных дорог",
          description: ""
        },
        {
          number: "1.7",
          images: ["1.7"],
          name: "Пересечение с круговым движением",
          description: ""
        },
        {
          number: "1.8",
          images: ["1.8"],
          name: "Светофорное регулирование",
          description:
            "Перекресток, пешеходный переход или участок дороги, движение на котором регулируется светофором."
        },
        {
          number: "1.9",
          images: ["1.9"],
          name: "Разводной мост",
          description: "Разводной мост или паромная переправа."
        },
        {
          number: "1.10",
          images: ["1.10"],
          name: "Выезд на набережную",
          description: "Выезд на набережную или берег."
        },
        {
          number: "1.11.1, 1.11.2",
          images: ["1.11.1", "1.11.2"],
          name: "Опасный поворот",
          description:
            "Закругление дороги малого радиуса или с ограниченной видимостью: 1.11.1 — направо, 1.11.2 — налево."
        },
        {
          number: "1.12.1, 1.12.2",
          images: ["1.12.1", "1.12.2"],
          name: "Опасные повороты",
          description:
            "Участок дороги с опасными поворотами: 1.12.1 — с первым поворотом направо, 1.12.2 — с первым поворотом налево."
        },
        {
          number: "1.13",
          images: ["1.13"],
          name: "Крутой спуск",
          description: ""
        },
        {
          number: "1.14",
          images: ["1.14"],
          name: "Крутой подъем",
          description: ""
        },
        {
          number: "1.15",
          images: ["1.15"],
          name: "Скользкая дорога",
          description:
            "Участок дороги с повышенной скользкостью проезжей части."
        },
        {
          number: "1.16",
          images: ["1.16"],
          name: "Неровная дорога",
          description:
            "Участок дороги, имеющий неровности на проезжей части (волнистость, выбоины, неплавные сопряжения с мостами и тому подобное)."
        },
        {
          number: "1.17",
          images: ["1.17"],
          name: "Искусственная неровность",
          description:
            "Участок дороги с искусственной неровностью (неровностями) для принудительного снижения скорости."
        },
        {
          number: "1.18",
          images: ["1.18"],
          name: "Выброс гравия",
          description:
            "Участок дороги, на котором возможен выброс гравия, щебня и тому подобного из-под колес транспортных средств."
        },
        {
          number: "1.19",
          images: ["1.19"],
          name: "Опасная обочина",
          description:
            "Участок дороги, на котором съезд на обочину опасен."
        },
        {
          number: "1.20.1 - 1.20.3",
          images: ["1.20.1", "1.20.2", "1.20.3"],
          name: "Сужение дороги",
          description:
            "Сужение с обеих сторон — 1.20.1, справа — 1.20.2, слева — 1.20.3."
        },
        {
          number: "1.21",
          images: ["1.21"],
          name: "Двустороннее движение",
          description:
            "Начало участка дороги (проезжей части) с встречным движением."
        },
        {
          number: "1.22",
          images: ["1.22"],
          name: "Пешеходный переход",
          description:
            "Пешеходный переход, обозначенный знаками 5.19.1, 5.19.2 и (или) разметкой 1.14.1 и 1.14.2."
        },
        {
          number: "1.23",
          images: ["1.23"],
          name: "Дети",
          description:
            "Участок дороги вблизи детского учреждения (школы, оздоровительного лагеря и тому подобного), на проезжей части которого возможно появление детей."
        },
        {
          number: "1.24",
          images: ["1.24"],
          name: "Пересечение с велосипедной дорожкой или велопешеходной дорожкой",
          description: ""
        },
        {
          number: "1.25",
          images: ["1.25"],
          name: "Дорожные работы",
          description: ""
        },
        {
          number: "1.26",
          images: ["1.26"],
          name: "Перегон скота",
          description: ""
        },
        {
          number: "1.27",
          images: ["1.27"],
          name: "Дикие животные",
          description: ""
        },
        {
          number: "1.28",
          images: ["1.28"],
          name: "Падение камней",
          description:
            "Участок дороги, на котором возможны обвалы, оползни, падение камней."
        },
        {
          number: "1.29",
          images: ["1.29"],
          name: "Боковой ветер",
          description: ""
        },
        {
          number: "1.30",
          images: ["1.30"],
          name: "Низколетящие самолеты",
          description: ""
        },
        {
          number: "1.31",
          images: ["1.31"],
          name: "Тоннель",
          description:
            "Тоннель, в котором отсутствует искусственное освещение, или тоннель, видимость въездного портала которого ограничена."
        },
        {
          number: "1.32",
          images: ["1.32"],
          name: "Затор",
          description:
            "Участок дороги, на котором образовался затор."
        },
        {
          number: "1.33",
          images: ["1.33"],
          name: "Прочие опасности",
          description:
            "Участок дороги, на котором имеются опасности, не предусмотренные другими предупреждающими знаками."
        },
        {
          number: "1.34.1, 1.34.2",
          images: ["1.34.1", "1.34.2"],
          name: "Направление поворота",
          description:
            "Направление движения на закруглении дороги малого радиуса с ограниченной видимостью. Направление объезда ремонтируемого участка дороги."
        },
        {
          number: "1.34.3",
          images: ["1.34.3"],
          name: "Направление поворота",
          description:
            "Направления движения на Т-образном перекрестке или разветвлении дорог. Направления объезда ремонтируемого участка дороги."
        },
        {
          number: "1.35",
          images: ["1.35"],
          name: "Участок перекрестка",
          description:
            "Обозначение приближения к перекрестку, участок которого обозначен разметкой 1.26 и на который запрещается выезжать, если впереди по пути следования образовался затор..."
        }
      ],
      notes: [
        "Предупреждающие знаки 1.1, 1.2, 1.5–1.33 вне населенных пунктов устанавливаются на расстоянии 150–300 м...",
        "Знаки 1.13 и 1.14 могут устанавливаться без таблички 8.1.1...",
        "Знак 1.25 при проведении краткосрочных работ...",
        "Знак 1.32 применяется в качестве временного...",
        "Знак 1.35 устанавливается на границе перекрестка...",
        "Вне населенных пунктов знаки 1.1, 1.2, 1.9, 1.10, 1.23 и 1.25 повторяются..."
      ]
    },
    {
      category: {
        name: "Знаки приоритета",
        img_icon: '/assets/znaki/2.1.svg',
        url: "prioriteta",
        description: "Знаки приоритета устанавливают очередность проезда перекрестков, пересечений проезжих частей или узких участков дороги."
      },
      seo: {
        title: "Знаки приоритета ПДД 2026 | ПДД",
        description: "Знаки приоритета в ПДД 2026: кто должен уступить дорогу, правила проезда перекрестков и значение каждого знака.",
        keywords: "знаки приоритета, ПДД приоритет, уступить дорогу, дорожные знаки, перекресток ПДД"
      },
      list: [
        {
          number: "2.1",
          images: ["2.1"],
          name: "Главная дорога",
          description: "Дорога, на которой предоставлено право преимущественного проезда нерегулируемых перекрестков."
        },
        {
          number: "2.2",
          images: ["2.2"],
          name: "Конец главной дороги",
          description: ""
        },
        {
          number: "2.3.1",
          images: ["2.3.1"],
          name: "Пересечение со второстепенной дорогой",
          description: ""
        },
        {
          number: "2.3.2 - 2.3.7",
          images: ["2.3.2", "2.3.3", "2.3.4", "2.3.5", "2.3.6", "2.3.7"],
          name: "Примыкание второстепенной дороги",
          description: "Примыкание справа — 2.3.2, 2.3.4, 2.3.6; слева — 2.3.3, 2.3.5, 2.3.7."
        },
        {
          number: "2.4",
          images: ["2.4"],
          name: "Уступите дорогу",
          description: "Водитель должен уступить дорогу транспортным средствам, движущимся по пересекаемой дороге, а при наличии таблички 8.13 — по главной."
        },
        {
          number: "2.5",
          images: ["2.5"],
          name: "Движение без остановки запрещено",
          description: "Запрещается движение без остановки перед стоп-линией, а если ее нет — перед краем пересекаемой проезжей части. Водитель должен уступить дорогу транспортным средствам, движущимся по пересекаемой, а при наличии таблички 8.13 — по главной дороге. Знак может быть установлен перед железнодорожным переездом или карантинным постом. В этих случаях водитель должен остановиться перед стоп-линией, а при ее отсутствии — перед знаком."
        },
        {
          number: "2.6",
          images: ["2.6"],
          name: "Преимущество встречного движения",
          description: "Запрещается въезд на узкий участок дороги, если это может затруднить встречное движение. Водитель должен уступить дорогу встречным транспортным средствам, находящимся на узком участке или противоположном подъезде к нему."
        },
        {
          number: "2.7",
          images: ["2.7"],
          name: "Преимущество перед встречным движением",
          description: "Узкий участок дороги, при движении по которому водитель пользуется преимуществом по отношению к встречным транспортным средствам."
        }
      ]
    },
    {
      category: {
        name: "Запрещающие знаки",
        img_icon: '/assets/znaki/3.1.svg',
        url: "zapreshchayushchie",
        description: "Запрещающие знаки вводят или отменяют определённые ограничения движения."
      },
      seo: {
        title: "Запрещающие знаки ПДД 2026 | ПДД",
        description: "Запрещающие знаки ПДД 2026: ограничения движения, въезда, обгона и остановки. Полный разбор значений и исключений.",
        keywords: "запрещающие знаки, ПДД запреты, знаки дорожного движения, ограничения ПДД, экзамен ГИБДД"
      },
      list: [
        {
          number: "3.1",
          images: ["3.1"],
          name: "Въезд запрещен",
          description: "Запрещается въезд всех транспортных средств в данном направлении."
        },
        {
          number: "3.2",
          images: ["3.2"],
          name: "Движение запрещено",
          description: "Запрещается движение всех транспортных средств."
        },
        {
          number: "3.3",
          images: ["3.3"],
          name: "Движение механических транспортных средств запрещено",
          description: "Запрещается движение механических транспортных средств."
        },
        {
          number: "3.4",
          images: ["3.4"],
          name: "Движение грузовых автомобилей запрещено",
          description: "Запрещается движение грузовых автомобилей и составов с разрешённой максимальной массой более 3,5 т (если не указано иное), а также тракторов и самоходных машин. Есть исключения для почтовых, спецсвязи и некоторых обслуживающих транспортных средств."
        },
        {
          number: "3.5",
          images: ["3.5"],
          name: "Движение мотоциклов запрещено",
          description: "Запрещается движение мотоциклов."
        },
        {
          number: "3.6",
          images: ["3.6"],
          name: "Движение тракторов запрещено",
          description: "Запрещается движение тракторов и самоходных машин."
        },
        {
          number: "3.7",
          images: ["3.7"],
          name: "Движение с прицепом запрещено",
          description: "Запрещается движение грузовых автомобилей и тракторов с прицепами, а также буксировка."
        },
        {
          number: "3.8",
          images: ["3.8"],
          name: "Движение гужевых повозок запрещено",
          description: "Запрещается движение гужевых повозок, верховых и вьючных животных, а также прогон скота."
        },
        {
          number: "3.9",
          images: ["3.9"],
          name: "Движение на велосипедах запрещено",
          description: "Запрещается движение велосипедов и мопедов."
        },
        {
          number: "3.10",
          images: ["3.10"],
          name: "Движение пешеходов запрещено",
          description: "Запрещается движение пешеходов и средств индивидуальной мобильности."
        },
        {
          number: "3.11",
          images: ["3.11"],
          name: "Ограничение массы",
          description: "Запрещается движение транспортных средств с фактической массой выше указанной на знаке."
        },
        {
          number: "3.12",
          images: ["3.12"],
          name: "Ограничение массы на ось",
          description: "Запрещается движение, если нагрузка на ось превышает указанное значение."
        },
        {
          number: "3.13",
          images: ["3.13"],
          name: "Ограничение высоты",
          description: "Запрещается движение транспортных средств выше указанной габаритной высоты."
        },
        {
          number: "3.14",
          images: ["3.14"],
          name: "Ограничение ширины",
          description: "Запрещается движение транспортных средств шире указанного габарита."
        },
        {
          number: "3.15",
          images: ["3.15"],
          name: "Ограничение длины",
          description: "Запрещается движение транспортных средств длиннее указанного значения."
        },
        {
          number: "3.16",
          images: ["3.16"],
          name: "Ограничение минимальной дистанции",
          description: "Запрещается движение с дистанцией меньше указанной на знаке."
        },
        {
          number: "3.17.1",
          images: ["3.17.1"],
          name: "Таможня",
          description: "Запрещается проезд без остановки у таможенного поста."
        },
        {
          number: "3.17.2",
          images: ["3.17.2"],
          name: "Опасность",
          description: "Запрещается дальнейшее движение из-за аварии, пожара или другой опасности."
        },
        {
          number: "3.17.3",
          images: ["3.17.3"],
          name: "Контроль",
          description: "Запрещается проезд без остановки через контрольные пункты."
        },
        {
          number: "3.18.1",
          images: ["3.18.1"],
          name: "Поворот направо запрещен",
          description: "Запрещён поворот направо."
        },
        {
          number: "3.18.2",
          images: ["3.18.2"],
          name: "Поворот налево запрещен",
          description: "Запрещён поворот налево."
        },
        {
          number: "3.19",
          images: ["3.19"],
          name: "Разворот запрещен",
          description: "Запрещён разворот."
        },
        {
          number: "3.20",
          images: ["3.20"],
          name: "Обгон запрещен",
          description: "Запрещён обгон всех транспортных средств, кроме отдельных исключений."
        },
        {
          number: "3.21",
          images: ["3.21"],
          name: "Конец зоны запрещения обгона",
          description: "Отмена действия знака 3.20."
        },
        {
          number: "3.22",
          images: ["3.22"],
          name: "Обгон грузовым автомобилям запрещен",
          description: "Запрещён обгон грузовыми автомобилями свыше 3,5 т."
        },
        {
          number: "3.23",
          images: ["3.23"],
          name: "Конец зоны запрещения обгона грузовым автомобилям",
          description: "Отмена действия знака 3.22."
        },
        {
          number: "3.24",
          images: ["3.24"],
          name: "Ограничение максимальной скорости",
          description: "Запрещается движение со скоростью выше указанной."
        },
        {
          number: "3.25",
          images: ["3.25"],
          name: "Конец ограничения скорости",
          description: "Отмена ограничения максимальной скорости."
        },
        {
          number: "3.26",
          images: ["3.26"],
          name: "Подача звукового сигнала запрещена",
          description: "Запрещено использование звукового сигнала, кроме предотвращения ДТП."
        },
        {
          number: "3.27",
          images: ["3.27"],
          name: "Остановка запрещена",
          description: "Запрещены остановка и стоянка транспортных средств."
        },
        {
          number: "3.28",
          images: ["3.28"],
          name: "Стоянка запрещена",
          description: "Запрещена стоянка транспортных средств."
        },
        {
          number: "3.29",
          images: ["3.29"],
          name: "Стоянка запрещена по нечётным числам",
          description: "Запрещена стоянка по нечётным числам месяца."
        },
        {
          number: "3.30",
          images: ["3.30"],
          name: "Стоянка запрещена по чётным числам",
          description: "Запрещена стоянка по чётным числам месяца."
        },
        {
          number: "3.31",
          images: ["3.31"],
          name: "Конец зоны всех ограничений",
          description: "Отмена действия ряда запрещающих знаков."
        },
        {
          number: "3.32",
          images: ["3.32"],
          name: "Движение с опасными грузами запрещено",
          description: "Запрещено движение транспортных средств с опасными грузами."
        },
        {
          number: "3.33",
          images: ["3.33"],
          name: "Движение с взрывчатыми и легковоспламеняющимися грузами запрещено",
          description: "Запрещена перевозка взрывчатых и легковоспламеняющихся веществ."
        },
        {
          number: "3.34",
          images: ["3.34"],
          name: "Движение автобусов запрещено",
          description: "Запрещено движение автобусов."
        },
        {
          number: "3.35",
          images: ["3.35"],
          name: "Движение СИМ запрещено",
          description: "Запрещено движение средств индивидуальной мобильности."
        }
      ]
    },
    {
      category: {
        name: "Предписывающие знаки",
        img_icon: '/assets/znaki/4.1.1.svg',
        url: "predpisyvayushchie",
        description: "Предписывающие знаки устанавливают обязательные направления движения, режимы движения и специальные предписания для участников дорожного движения."
      },
      seo: {
        title: "Предписывающие знаки ПДД 2026 | ПДД",
        description: "Предписывающие знаки ПДД 2026: обязательные направления движения, правила проезда и требования для водителей.",
        keywords: "предписывающие знаки, ПДД направление движения, обязательные знаки, дорожные знаки"
      },
      list: [
        {
          number: "4.1.1",
          images: ["4.1.1"],
          name: "Движение прямо",
          description: "Разрешается движение только прямо."
        },
        {
          number: "4.1.2",
          images: ["4.1.2"],
          name: "Движение направо",
          description: "Разрешается движение только направо."
        },
        {
          number: "4.1.3",
          images: ["4.1.3"],
          name: "Движение налево",
          description: "Разрешается движение только налево."
        },
        {
          number: "4.1.4",
          images: ["4.1.4"],
          name: "Движение прямо или направо",
          description: "Разрешается движение прямо или направо."
        },
        {
          number: "4.1.5",
          images: ["4.1.5"],
          name: "Движение прямо или налево",
          description: "Разрешается движение прямо или налево."
        },
        {
          number: "4.1.6",
          images: ["4.1.6"],
          name: "Движение направо или налево",
          description: "Разрешается движение направо или налево. Поворот налево также допускает разворот."
        },
        {
          number: "4.2.1",
          images: ["4.2.1"],
          name: "Объезд препятствия справа",
          description: "Объезд разрешается только справа."
        },
        {
          number: "4.2.2",
          images: ["4.2.2"],
          name: "Объезд препятствия слева",
          description: "Объезд разрешается только слева."
        },
        {
          number: "4.2.3",
          images: ["4.2.3"],
          name: "Объезд препятствия справа или слева",
          description: "Объезд разрешается с любой стороны."
        },
        {
          number: "4.3",
          images: ["4.3"],
          name: "Круговое движение",
          description: "Движение осуществляется по кругу в направлении стрелок."
        },
        {
          number: "4.4.1",
          images: ["4.4.1"],
          name: "Велосипедная дорожка",
          description: "Разрешено движение велосипедистов."
        },
        {
          number: "4.4.2",
          images: ["4.4.2"],
          name: "Конец велосипедной дорожки",
          description: "Обозначает конец велосипедной дорожки."
        },
        {
          number: "4.5.1",
          images: ["4.5.1"],
          name: "Пешеходная дорожка",
          description: "Разрешено движение пешеходов, СИМ и велосипедистов в предусмотренных случаях."
        },
        {
          number: "4.5.2",
          images: ["4.5.2"],
          name: "Пешеходная и велосипедная дорожка (совмещённая)",
          description: "Совмещённое движение пешеходов и велосипедистов."
        },
        {
          number: "4.5.3",
          images: ["4.5.3"],
          name: "Конец совмещённой дорожки",
          description: "Окончание совмещённой пешеходно-велосипедной дорожки."
        },
        {
          number: "4.5.4 - 4.5.5",
          images: ["4.5.4", "4.5.5"],
          name: "Пешеходная и велосипедная дорожка с разделением движения",
          description: "Дорожка с разделением потоков пешеходов и велосипедистов."
        },
        {
          number: "4.5.6 - 4.5.7",
          images: ["4.5.6", "4.5.7"],
          name: "Конец дорожки с разделением движения",
          description: "Окончание разделённой пешеходно-велосипедной дорожки."
        },
        {
          number: "4.6",
          images: ["4.6"],
          name: "Ограничение минимальной скорости",
          description: "Разрешается движение только со скоростью не ниже указанной."
        },
        {
          number: "4.7",
          images: ["4.7"],
          name: "Конец ограничения минимальной скорости",
          description: "Отмена действия знака минимальной скорости."
        },
        {
          number: "4.8.1",
          images: ["4.8.1"],
          name: "Направление движения с опасными грузами (прямо)",
          description: "Транспорт с опасными грузами должен двигаться прямо."
        },
        {
          number: "4.8.2",
          images: ["4.8.2"],
          name: "Направление движения с опасными грузами (направо)",
          description: "Транспорт с опасными грузами должен двигаться направо."
        },
        {
          number: "4.8.3",
          images: ["4.8.3"],
          name: "Направление движения с опасными грузами (налево)",
          description: "Транспорт с опасными грузами должен двигаться налево."
        }
      ]
    },
    {
      category: {
        name: "Знаки особых предписаний",
        img_icon: '/assets/znaki/5.5.svg',
        url: "osobykh-predpisaniy",
        description: "Знаки особых предписаний вводят или отменяют определённые режимы движения и устанавливают специальные правила на участках дорог."
      },
      seo: {
        title: "Знаки особых предписаний ПДД 2026 | ПДД",
        description: "Знаки особых предписаний ПДД 2026: особенности движения на отдельных участках дорог и специальные режимы движения.",
        keywords: "знаки особых предписаний, ПДД режим движения, дороги ПДД, специальные зоны"
      },
      list: [
        {
          number: "5.1",
          images: ["5.1"],
          name: "Автомагистраль",
          description: "Дорога, на которой действуют специальные правила движения, установленные для автомагистралей."
        },
        {
          number: "5.2",
          images: ["5.2"],
          name: "Конец автомагистрали",
          description: "Отмена действия знака «Автомагистраль»."
        },
        {
          number: "5.3",
          images: ["5.3"],
          name: "Дорога для автомобилей",
          description: "Дорога, предназначенная для движения только автомобилей, автобусов и мотоциклов."
        },
        {
          number: "5.4",
          images: ["5.4"],
          name: "Конец дороги для автомобилей",
          description: "Отмена действия знака «Дорога для автомобилей»."
        },
        {
          number: "5.5",
          images: ["5.5"],
          name: "Дорога с односторонним движением",
          description: "Движение осуществляется в одном направлении по всей ширине дороги."
        },
        {
          number: "5.6",
          images: ["5.6"],
          name: "Конец дороги с односторонним движением",
          description: "Отмена действия одностороннего движения."
        },
        {
          number: "5.7.1 - 5.7.2",
          images: ["5.7.1", "5.7.2"],
          name: "Выезд на дорогу с односторонним движением",
          description: "Обозначает выезд на дорогу с односторонним движением."
        },
        {
          number: "5.8",
          images: ["5.8"],
          name: "Реверсивное движение",
          description: "Участок дороги с изменяемым направлением движения по полосам."
        },
        {
          number: "5.9",
          images: ["5.9"],
          name: "Конец реверсивного движения",
          description: "Отмена реверсивного движения."
        },
        {
          number: "5.10",
          images: ["5.10"],
          name: "Выезд на дорогу с реверсивным движением",
          description: "Обозначает выезд на дорогу с реверсивным движением."
        },
        {
          number: "5.11.1",
          images: ["5.11.1"],
          name: "Полоса для маршрутных транспортных средств",
          description: "Выделенная полоса для общественного транспорта, движущегося навстречу общему потоку."
        },
        {
          number: "5.11.2",
          images: ["5.11.2"],
          name: "Полоса для велосипедистов",
          description: "Выделенная полоса для велосипедистов, СИМ и мопедов."
        },
        {
          number: "5.12.1",
          images: ["5.12.1"],
          name: "Конец полосы для маршрутных транспортных средств",
          description: "Отмена выделенной полосы для маршрутных транспортных средств."
        },
        {
          number: "5.12.2",
          images: ["5.12.2"],
          name: "Конец полосы для велосипедистов",
          description: "Отмена выделенной полосы для велосипедистов."
        },
        {
          number: "5.13.1 - 5.13.4",
          images: ["5.13.1", "5.13.2", "5.13.3", "5.13.4"],
          name: "Выезд на дорогу с выделенными полосами",
          description: "Обозначает выезд на дорогу с полосой для маршрутных транспортных средств или велосипедистов."
        },
        {
          number: "5.14.1",
          images: ["5.14.1"],
          name: "Полоса для маршрутных транспортных средств",
          description: "Выделенная полоса для движения маршрутного транспорта."
        },
        {
          number: "5.14.2",
          images: ["5.14.2"],
          name: "Полоса для велосипедистов",
          description: "Выделенная полоса для велосипедистов."
        },
        {
          number: "5.14.3",
          images: ["5.14.3"],
          name: "Конец полосы для маршрутных транспортных средств",
          description: "Отмена полосы для маршрутного транспорта."
        },
        {
          number: "5.14.4",
          images: ["5.14.4"],
          name: "Конец полосы для велосипедистов",
          description: "Отмена полосы для велосипедистов."
        },
        {
          number: "5.15.1",
          images: ["5.15.1"],
          name: "Направления движения по полосам",
          description: "Определяет направления движения по каждой полосе."
        },
        {
          number: "5.15.2",
          images: ["5.15.2"],
          name: "Направления движения по полосе",
          description: "Указывает разрешённые направления движения по конкретной полосе."
        },
        {
          number: "5.15.3",
          images: ["5.15.3"],
          name: "Начало полосы",
          description: "Начало дополнительной полосы или полосы разгона/торможения."
        },
        {
          number: "5.15.4",
          images: ["5.15.4"],
          name: "Начало полосы",
          description: "Начало средней полосы для движения в заданном направлении."
        },
        {
          number: "5.15.5",
          images: ["5.15.5"],
          name: "Конец полосы",
          description: "Окончание дополнительной полосы."
        },
        {
          number: "5.15.6",
          images: ["5.15.6"],
          name: "Конец полосы",
          description: "Окончание средней полосы движения."
        },
        {
          number: "5.15.7",
          images: ["5.15.7"],
          name: "Направление движения по полосам",
          description: "Определяет направления движения и возможные ограничения по полосам."
        },
        {
          number: "5.15.8",
          images: ["5.15.8"],
          name: "Число полос",
          description: "Указывает количество полос и режимы движения."
        },
        {
          number: "5.16",
          images: ["5.16"],
          name: "Место остановки автобуса",
          description: "Место остановки общественного транспорта."
        },
        {
          number: "5.17",
          images: ["5.17"],
          name: "Место остановки трамвая",
          description: "Место остановки трамвая."
        },
        {
          number: "5.18",
          images: ["5.18"],
          name: "Место стоянки такси",
          description: "Место стоянки легковых такси."
        },
        {
          number: "5.19.1 - 5.19.2",
          images: ["5.19.1", "5.19.2"],
          name: "Пешеходный переход",
          description: "Обозначает пешеходный переход."
        },
        {
          number: "5.20",
          images: ["5.20"],
          name: "Искусственная неровность",
          description: "Обозначает границы искусственной неровности."
        },
        {
          number: "5.21",
          images: ["5.21"],
          name: "Жилая зона",
          description: "Территория с особыми правилами движения в жилой зоне."
        },
        {
          number: "5.22",
          images: ["5.22"],
          name: "Конец жилой зоны",
          description: "Отмена действия жилой зоны."
        },
        {
          number: "5.23.1 - 5.23.2",
          images: ["5.23.1", "5.23.2"],
          name: "Начало населённого пункта",
          description: "Обозначает начало населённого пункта."
        },
        {
          number: "5.24.1 - 5.24.2",
          images: ["5.24.1", "5.24.2"],
          name: "Конец населённого пункта",
          description: "Обозначает конец населённого пункта."
        },
        {
          number: "5.25",
          images: ["5.25"],
          name: "Начало населённого пункта (без ПДД режима)",
          description: "Начало населённого пункта, где не действуют правила движения в населённых пунктах."
        },
        {
          number: "5.26",
          images: ["5.26"],
          name: "Конец населённого пункта",
          description: "Конец населённого пункта на данной дороге."
        },
        {
          number: "5.27",
          images: ["5.27"],
          name: "Зона с ограничением стоянки",
          description: "Начало зоны, где стоянка запрещена."
        },
        {
          number: "5.28",
          images: ["5.28"],
          name: "Конец зоны с ограничением стоянки",
          description: "Окончание зоны ограничения стоянки."
        },
        {
          number: "5.29",
          images: ["5.29"],
          name: "Зона регулируемой стоянки",
          description: "Зона, где стоянка регулируется разметкой и табличками."
        },
        {
          number: "5.30",
          images: ["5.30"],
          name: "Конец зоны регулируемой стоянки",
          description: "Окончание зоны регулируемой стоянки."
        },
        {
          number: "5.31",
          images: ["5.31"],
          name: "Зона с ограничением максимальной скорости",
          description: "Зона с ограничением скорости движения."
        },
        {
          number: "5.32",
          images: ["5.32"],
          name: "Конец зоны с ограничением максимальной скорости",
          description: "Отмена ограничения скорости в зоне."
        },
        {
          number: "5.33",
          images: ["5.33"],
          name: "Пешеходная зона",
          description: "Зона, предназначенная для движения пешеходов и СИМ в разрешённых случаях."
        },
        {
          number: "5.34",
          images: ["5.34"],
          name: "Конец пешеходной зоны",
          description: "Отмена пешеходной зоны."
        },
        {
          number: "5.35",
          images: ["5.35"],
          name: "Зона с ограничением экологического класса",
          description: "Запрещает движение транспортных средств с низким экологическим классом."
        },
        {
          number: "5.36",
          images: ["5.36"],
          name: "Конец зоны с ограничением экологического класса",
          description: "Отмена экологических ограничений."
        },
        {
          number: "5.37",
          images: ["5.37"],
          name: "Зона ограничения экологического класса по видам ТС",
          description: "Ограничение движения по экологическому классу и типу транспортных средств."
        },
        {
          number: "5.38",
          images: ["5.38"],
          name: "Конец зоны с ограничением экологического класса по видам ТС",
          description: "Отмена экологических ограничений по типам ТС."
        },
        {
          number: "5.39",
          images: ["5.39"],
          name: "Велосипедная зона",
          description: "Зона, предназначенная преимущественно для велосипедистов."
        },
        {
          number: "5.40",
          images: ["5.40"],
          name: "Конец велосипедной зоны",
          description: "Окончание велосипедной зоны."
        }
      ]
    },
    {
      category: {
        name: "Информационные знаки",
        img_icon: '/assets/znaki/6.4.svg',
        url: "informatsionnye",
        description: "Информационные знаки информируют о расположении населённых пунктов, объектов, а также об установленных или рекомендуемых режимах движения."
      },
      seo: {
        title: "Информационные знаки ПДД 2026 | ПДД",
        description: "Информационные знаки ПДД 2026: навигация, направления движения, расстояния и полезная дорожная информация для водителей.",
        keywords: "информационные знаки, ПДД информация, дорожная навигация, указатели дорог"
      },
      list: [
        {
          number: "6.1",
          images: ["6.1"],
          name: "Общие ограничения максимальной скорости",
          description: "Общие ограничения скорости, установленные правилами дорожного движения."
        },
        {
          number: "6.2",
          images: ["6.2"],
          name: "Рекомендуемая скорость",
          description: "Рекомендуемая скорость движения на участке дороги."
        },
        {
          number: "6.3.1",
          images: ["6.3.1"],
          name: "Место для разворота",
          description: "Место, предназначенное для разворота. Поворот налево запрещён."
        },
        {
          number: "6.3.2",
          images: ["6.3.2"],
          name: "Зона для разворота",
          description: "Протяжённая зона для разворота. Поворот налево запрещён."
        },
        {
          number: "6.4",
          images: ["6.4"],
          name: "Парковка (парковочное место)",
          description: "Обозначает место парковки. Может указывать на платную парковку или парковку для инвалидов."
        },
        {
          number: "6.5",
          images: ["6.5"],
          name: "Полоса аварийной остановки",
          description: "Полоса для аварийной остановки на крутых спусках."
        },
        {
          number: "6.6",
          images: ["6.6"],
          name: "Подземный пешеходный переход",
          description: "Указывает подземный пешеходный переход."
        },
        {
          number: "6.7",
          images: ["6.7"],
          name: "Надземный пешеходный переход",
          description: "Указывает надземный пешеходный переход."
        },
        {
          number: "6.8.1 - 6.8.3",
          images: ["6.8.1", "6.8.2", "6.8.3"],
          name: "Тупик",
          description: "Дорога без сквозного проезда."
        },
        {
          number: "6.9.1",
          images: ["6.9.1"],
          name: "Предварительный указатель направлений",
          description: "Указывает направления движения к населенным пунктам и объектам."
        },
        {
          number: "6.9.2",
          images: ["6.9.2"],
          name: "Предварительный указатель направления",
          description: "Указывает направление движения к объектам и населенным пунктам."
        },
        {
          number: "6.9.3",
          images: ["6.9.3"],
          name: "Схема движения",
          description: "Схема маршрута при сложных перекрёстках или запретах манёвров."
        },
        {
          number: "6.10.1",
          images: ["6.10.1"],
          name: "Указатель направлений",
          description: "Направления движения к пунктам маршрута."
        },
        {
          number: "6.10.2",
          images: ["6.10.2"],
          name: "Указатель направления",
          description: "Направление движения к объектам маршрута."
        },
        {
          number: "6.11",
          images: ["6.11"],
          name: "Наименование объекта",
          description: "Название географического или иного объекта."
        },
        {
          number: "6.12",
          images: ["6.12"],
          name: "Указатель расстояний",
          description: "Расстояние до населённых пунктов."
        },
        {
          number: "6.13",
          images: ["6.13"],
          name: "Километровый знак",
          description: "Расстояние до начала или конца дороги."
        },
        {
          number: "6.14.1 - 6.14.2",
          images: ["6.14.1", "6.14.2"],
          name: "Номер маршрута",
          description: "Обозначение номера дороги или маршрута."
        },
        {
          number: "6.15.1 - 6.15.3",
          images: ["6.15.1", "6.15.2", "6.15.3"],
          name: "Направление движения для грузовых автомобилей",
          description: "Рекомендуемое направление для грузового транспорта."
        },
        {
          number: "6.16",
          images: ["6.16"],
          name: "Стоп-линия",
          description: "Место остановки перед светофором или регулировщиком."
        },
        {
          number: "6.17",
          images: ["6.17"],
          name: "Схема объезда",
          description: "Маршрут объезда закрытого участка дороги."
        },
        {
          number: "6.18.1 - 6.18.3",
          images: ["6.18.1", "6.18.2", "6.18.3"],
          name: "Направление объезда",
          description: "Указывает направление объезда закрытого участка дороги."
        },
        {
          number: "6.19.1 - 6.19.2",
          images: ["6.19.1", "6.19.2"],
          name: "Предварительный указатель перестроения",
          description: "Указывает направление перестроения или возврата на проезжую часть."
        },
        {
          number: "6.20.1 - 6.20.2",
          images: ["6.20.1", "6.20.2"],
          name: "Аварийный выход",
          description: "Обозначает места аварийного выхода в тоннеле."
        },
        {
          number: "6.21.1 - 6.21.2",
          images: ["6.21.1", "6.21.2"],
          name: "Направление к аварийному выходу",
          description: "Указывает направление и расстояние до аварийного выхода."
        },
        {
          number: "6.22",
          images: ["6.22"],
          name: "Фотовидеофиксация",
          description: "Обозначает зоны автоматической фиксации нарушений ПДД."
        }
      ]
    },
    {
      category: {
        name: "Знаки сервиса",
        img_icon: '/assets/znaki/7.3.svg',
        url: "servisa",
        description: "Знаки сервиса информируют участников дорожного движения о расположении объектов обслуживания и инфраструктуры."
      },
      seo: {
        title: "Знаки сервиса ПДД 2026 | ПДД",
        description: "Знаки сервиса ПДД 2026: обозначения АЗС, больниц, гостиниц, стоянок и других объектов дорожной инфраструктуры.",
        keywords: "знаки сервиса, АЗС, парковка, гостиница, дорожные услуги"
      },
      list: [
        {
          number: "7.1",
          images: ["7.1"],
          name: "Пункт медицинской помощи",
          description: "Обозначает наличие пункта медицинской помощи."
        },
        {
          number: "7.2",
          images: ["7.2"],
          name: "Больница",
          description: "Указывает расположение больницы."
        },
        {
          number: "7.3",
          images: ["7.3"],
          name: "Автозаправочная станция",
          description: "Обозначает автозаправочную станцию."
        },
        {
          number: "7.4",
          images: ["7.4"],
          name: "Техническое обслуживание автомобилей",
          description: "Указывает место технического обслуживания автомобилей."
        },
        {
          number: "7.5",
          images: ["7.5"],
          name: "Мойка автомобилей",
          description: "Обозначает автомойку."
        },
        {
          number: "7.6",
          images: ["7.6"],
          name: "Телефон",
          description: "Указывает наличие телефона связи."
        },
        {
          number: "7.7",
          images: ["7.7"],
          name: "Пункт питания",
          description: "Обозначает место общественного питания."
        },
        {
          number: "7.8",
          images: ["7.8"],
          name: "Питьевая вода",
          description: "Указывает наличие питьевой воды."
        },
        {
          number: "7.9",
          images: ["7.9"],
          name: "Гостиница или мотель",
          description: "Обозначает гостиницу или мотель."
        },
        {
          number: "7.10",
          images: ["7.10"],
          name: "Кемпинг",
          description: "Указывает место для кемпинга."
        },
        {
          number: "7.11",
          images: ["7.11"],
          name: "Место отдыха",
          description: "Обозначает место отдыха для водителей и пассажиров."
        },
        {
          number: "7.12",
          images: ["7.12"],
          name: "Пост дорожно-патрульной службы",
          description: "Указывает пост ДПС."
        },
        {
          number: "7.13",
          images: ["7.13"],
          name: "Полиция",
          description: "Обозначает пункт полиции."
        },
        {
          number: "7.14.1",
          images: ["7.14.1"],
          name: "Пункт таможенного контроля",
          description: "Указывает таможенный контрольный пункт."
        },
        {
          number: "7.14.2",
          images: ["7.14.2"],
          name: "Пункт транспортного контроля",
          description: "Обозначает пункт транспортного контроля."
        },
        {
          number: "7.15",
          images: ["7.15"],
          name: "Зона приема радиостанции",
          description: "Участок дороги с приемом информации о дорожном движении по радиоканалу."
        },
        {
          number: "7.16",
          images: ["7.16"],
          name: "Зона радиосвязи с аварийными службами",
          description: "Участок дороги с доступом к радиосвязи аварийных служб."
        },
        {
          number: "7.17",
          images: ["7.17"],
          name: "Бассейн или пляж",
          description: "Обозначает место отдыха у воды."
        },
        {
          number: "7.18",
          images: ["7.18"],
          name: "Туалет",
          description: "Указывает наличие туалета."
        },
        {
          number: "7.19",
          images: ["7.19"],
          name: "Телефон экстренной связи",
          description: "Место установки телефона для вызова экстренных служб."
        },
        {
          number: "7.20",
          images: ["7.20"],
          name: "Огнетушитель",
          description: "Указывает место размещения огнетушителя."
        },
        {
          number: "7.21",
          images: ["7.21"],
          name: "Автозаправочная станция с зарядкой электромобилей",
          description: "Обозначает АЗС с возможностью зарядки электромобилей."
        }
      ]
    },
    {
      category: {
        name: "Знаки дополнительной информации (таблички)",
        img_icon: '/assets/znaki/8.1.2.svg',
        url: "dopolnitelnoy-informatsii-tablichki",
        description: "Таблички уточняют или ограничивают действие дорожных знаков, с которыми они применяются, либо содержат дополнительную информацию для участников дорожного движения."
      },
      seo: {
        title: "Знаки дополнительной информации (таблички) ПДД 2026 | ПДД",
        description: "Таблички ПДД 2026: знаки дополнительной информации, уточняющие действие основных дорожных знаков и условий их применения.",
        keywords: "таблички ПДД, дополнительная информация, дорожные знаки, уточняющие знаки"
      },
      list: [
        {
          number: "8.1.1",
          images: ["8.1.1"],
          name: "Расстояние до объекта",
          description: "Указывает расстояние от знака до начала опасного участка, ограничения или объекта."
        },
        {
          number: "8.1.2",
          images: ["8.1.2"],
          name: "Расстояние до объекта",
          description: "Указывает расстояние до перекрёстка или объекта в связке со знаками приоритета."
        },
        {
          number: "8.1.3 - 8.1.4",
          images: ["8.1.3", "8.1.4"],
          name: "Расстояние до объекта",
          description: "Указывают расстояние до объекта, находящегося в стороне от дороги."
        },
        {
          number: "8.2.1",
          images: ["8.2.1"],
          name: "Зона действия",
          description: "Определяет протяжённость зоны действия предупреждающих и запрещающих знаков."
        },
        {
          number: "8.2.2 - 8.2.6",
          images: ["8.2.2", "8.2.3", "8.2.4", "8.2.5", "8.2.6"],
          name: "Зона действия",
          description: "Уточняют начало, конец и направление зоны действия запрещающих знаков."
        },
        {
          number: "8.3.1 - 8.3.3",
          images: ["8.3.1", "8.3.2", "8.3.3"],
          name: "Направления действия",
          description: "Указывают направление действия знаков или движение к объектам."
        },
        {
          number: "8.4.1 - 8.4.8",
          images: [
            "8.4.1",
            "8.4.2",
            "8.4.3",
            "8.4.4",
            "8.4.5",
            "8.4.6",
            "8.4.7",
            "8.4.8"
          ],
          name: "Вид транспортного средства",
          description: "Указывают тип транспортных средств, на которые распространяется действие знака."
        },
        {
          number: "8.4.3.1",
          images: ["8.4.3.1"],
          name: "На электромобили",
          description: "Распространяет действие знака на электромобили и подключаемые гибриды."
        },
        {
          number: "8.4.3.2",
          images: ["8.4.3.2"],
          name: "На легковые автомобили",
          description: "Распространяет действие знака на легковые автомобили и грузовые до 3,5 т."
        },
        {
          number: "8.4.7.1",
          images: ["8.4.7.1"],
          name: "На велосипедистов",
          description: "Распространяет действие знака на велосипедистов."
        },
        {
          number: "8.4.7.2",
          images: ["8.4.7.2"],
          name: "На СИМ",
          description: "Распространяет действие знака на средства индивидуальной мобильности."
        },
        {
          number: "8.4.9 - 8.4.16",
          images: [
            "8.4.9",
            "8.4.10",
            "8.4.11",
            "8.4.12",
            "8.4.13",
            "8.4.14",
            "8.4.15",
            "8.4.16"
          ],
          name: "Кроме вида транспортного средства",
          description: "Указывают виды транспортных средств, на которые действие знака не распространяется."
        },
        {
          number: "8.5.1",
          images: ["8.5.1"],
          name: "Субботние, воскресные и праздничные дни",
          description: "Указывает действие знака по выходным и праздничным дням."
        },
        {
          number: "8.5.2",
          images: ["8.5.2"],
          name: "Рабочие дни",
          description: "Указывает действие знака в рабочие дни."
        },
        {
          number: "8.5.3",
          images: ["8.5.3"],
          name: "Дни недели",
          description: "Указывает конкретные дни недели действия знака."
        },
        {
          number: "8.5.4",
          images: ["8.5.4"],
          name: "Время действия",
          description: "Указывает время суток действия знака."
        },
        {
          number: "8.5.5 - 8.5.7",
          images: ["8.5.5", "8.5.6", "8.5.7"],
          name: "Время действия",
          description: "Указывают дни недели и время суток действия знака."
        },
        {
          number: "8.6.1 - 8.6.9",
          images: [
            "8.6.1",
            "8.6.2",
            "8.6.3",
            "8.6.4",
            "8.6.5",
            "8.6.6",
            "8.6.7",
            "8.6.8",
            "8.6.9"
          ],
          name: "Способ постановки на стоянку",
          description: "Указывают способ размещения транспортных средств на парковке."
        },
        {
          number: "8.7",
          images: ["8.7"],
          name: "Стоянка с неработающим двигателем",
          description: "Разрешает стоянку только с выключенным двигателем."
        },
        {
          number: "8.8",
          images: ["8.8"],
          name: "Платные услуги",
          description: "Указывает, что услуги предоставляются на платной основе."
        },
        {
          number: "8.9.1",
          images: ["8.9.1"],
          name: "Ограничение продолжительности стоянки",
          description: "Ограничивает максимальное время стоянки."
        },
        {
          number: "8.9.2",
          images: ["8.9.2"],
          name: "Стоянка только для владельцев парковочных разрешений",
          description: "Разрешает стоянку только при наличии парковочного разрешения."
        },
        {
          number: "8.9.3",
          images: ["8.9.3"],
          name: "Стоянка для дипломатического корпуса",
          description: "Предназначена только для транспортных средств диппредставительств."
        },
        {
          number: "8.10",
          images: ["8.10"],
          name: "Место для осмотра автомобилей",
          description: "Указывает наличие эстакады или смотровой канавы."
        },
        {
          number: "8.11",
          images: ["8.11"],
          name: "Ограничение разрешённой максимальной массы",
          description: "Ограничивает действие знака по массе транспортного средства."
        },
        {
          number: "8.12",
          images: ["8.12"],
          name: "Опасная обочина",
          description: "Предупреждает об опасности съезда на обочину."
        },
        {
          number: "8.13",
          images: ["8.13"],
          name: "Направление главной дороги",
          description: "Указывает направление главной дороги на перекрёстке."
        },
        {
          number: "8.14",
          images: ["8.14"],
          name: "Полоса движения",
          description: "Указывает полосу действия знака или светофора."
        },
        {
          number: "8.15",
          images: ["8.15"],
          name: "Слепые пешеходы",
          description: "Указывает, что переход используется слепыми пешеходами."
        },
        {
          number: "8.16",
          images: ["8.16"],
          name: "Влажное покрытие",
          description: "Действие знака распространяется на период влажного покрытия."
        },
        {
          number: "8.17",
          images: ["8.17"],
          name: "Инвалиды",
          description: "Распространяет действие знака на транспорт инвалидов."
        },
        {
          number: "8.18",
          images: ["8.18"],
          name: "Кроме инвалидов",
          description: "Исключает транспорт инвалидов из действия знака."
        },
        {
          number: "8.19",
          images: ["8.19"],
          name: "Класс опасного груза",
          description: "Указывает класс опасного груза."
        },
        {
          number: "8.20.1 - 8.20.2",
          images: ["8.20.1", "8.20.2"],
          name: "Тип тележки транспортного средства",
          description: "Указывает допустимую нагрузку на оси."
        },
        {
          number: "8.21.1 - 8.21.3",
          images: ["8.21.1", "8.21.2", "8.21.3"],
          name: "Вид маршрутного транспортного средства",
          description: "Обозначает места остановок и пересадок на общественный транспорт."
        },
        {
          number: "8.22.1 - 8.22.3",
          images: ["8.22.1", "8.22.2", "8.22.3"],
          name: "Препятствие",
          description: "Указывает направление объезда препятствия."
        },
        {
          number: "8.24",
          images: ["8.24"],
          name: "Работает эвакуатор",
          description: "Сообщает о возможной эвакуации транспортных средств."
        },
        {
          number: "8.25",
          images: ["8.25"],
          name: "Экологический класс транспортного средства",
          description: "Ограничивает действие знаков по экологическому классу транспортных средств."
        },
        {
          number: "8.26",
          images: ["8.26"],
          name: "Зарядка электромобилей",
          description: "Указывает место зарядки электромобилей."
        }
      ]
    }
  ]

}
